<style>
#footer {
  width: 100%;
  padding: 32px 0;
  background-color: #2E3033;
  color: #ccc;
}
#footer .co-info p{
  margin: 15px 0;
}
#footer .co-info .co-links{
  padding: 0;
  list-style: none;
  margin: 0;
}
#footer .co-info .co-links li{
  float: left;
  margin-right: 15px;
}
#footer .co-info .co-links li a{
  text-decoration: none;
  color: white;
}

#footer .co-info p:last-child{
  margin-bottom: 0;
}
#footer .co-logo{
  background: url('../../assets/common/c_logo.svg') no-repeat;
  height: 74px;
}
</style>

<template>
  <div id="footer">
    <el-row class="container">
      <el-col :span="20" class="co-info">
        <ul class="co-links clearfix">
            <li><a href="http://www.18show.cn/r?gsZHb" target="_blank">关于我们</a></li>
            <li><a href="http://www.18show.cn/r?4sZHb" target="_blank">易展动态</a></li>
            <li><a href="http://www.18show.cn/r?CsZHb" target="_blank">易展荣誉</a></li>
            <li><a href="http://www.18show.cn/r?LsZHb" target="_blank">易展服务</a></li>
            <li><a href="http://www.18show.cn/r?WsZHb" target="_blank">易家文化</a></li>
            <li><a href="http://www.18show.cn/r?GtZHb" target="_blank">英才集结号</a></li>
            <li><a href="http://www.18show.cn/r?euZHb" target="_blank">社会责任</a></li>
            <li><a href="http://www.18show.cn/r?N5Oeb" target="_blank">联系我们</a></li>
        </ul>
        <p>备案号：粤ICP备11010883号-1 公安机关备案号：44040202000312 本站所有关键词指数仅供参考，最终解释权归易展所有</p>
        <p>Copyright©2004-2017  珠海市金信桥网络科技有限公司 版权所有</p>
      </el-col>
      <el-col :span="4" class="co-logo"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// footer.vue?11769828